import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/message_detail_arrow.png';
const _withScopeId = n => (_pushScopeId("data-v-2354f776"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  class: "list"
};
const _hoisted_3 = {
  class: "item-time"
};
const _hoisted_4 = {
  class: "item-body"
};
const _hoisted_5 = {
  class: "item-body-title"
};
const _hoisted_6 = {
  class: "item-body-content"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-body-line"
}, null, -1));
const _hoisted_8 = ["onClick"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-body-btn-text"
}, "查看详情", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "item-body-btn-img",
  src: _imports_0
}, null, -1));
const _hoisted_11 = [_hoisted_9, _hoisted_10];
import { ref, onMounted, getCurrentInstance, createApp } from 'vue';
import { PullRefresh } from 'vant';
import { toServerRouting } from '@/utils/navitiveApi/common';
import { useRouter, useRoute } from 'vue-router';
import { getMessageListApi, readApi } from '@/api/message';
export default {
  __name: 'MessageList',
  setup(__props) {
    var _getCurrentInstance$p, _getCurrentInstance;
    const {
      $alert,
      $loading
    } = (_getCurrentInstance$p = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) !== null && _getCurrentInstance$p !== void 0 ? _getCurrentInstance$p : {};
    const app = createApp();
    app.use(PullRefresh);
    const route = useRoute();
    //标题
    const showTitle = ref('');
    const refreshing = ref(true);
    const loading = ref(false);
    const finished = ref(false);
    var pageSize = 10;
    var pageNum = 1;
    const messageList = ref([]);
    const emptyShow = ref(false);
    const {
      title,
      type
    } = route.query;
    showTitle.value = title;
    onMounted(() => {
      initData();
      window['shouldHideTitleBar'] = () => {
        return true;
      };
    });
    const initData = async () => {
      await getData();
      setTimeout(() => {
        readMethod();
      }, 1000);
    };
    const getDateTime = time => {
      var _timeParts$;
      var timeParts = time.split(".");
      return (_timeParts$ = timeParts[0]) !== null && _timeParts$ !== void 0 ? _timeParts$ : '';
    };
    const getData = async () => {
      pageNum = 1;
      finished.value = false;
      loading.value = true;
      messageList.value = [];
      await loadData();
    };
    const loadData = async () => {
      try {
        const {
          code,
          message,
          data
        } = await getMessageListApi({
          type,
          pageNum,
          pageSize
        });
        refreshing.value = false;
        if (refreshing.value) {
          refreshing.value = false;
        }
        loading.value = false;
        if (code !== 9000) {
          $alert({
            message
          });
          return;
        }
        pageNum = data.next;
        messageList.value = [...messageList.value, ...data.rows];
        if (data.rows.length < pageSize) {
          finished.value = true;
        }
        if (messageList.value.length == 0) {
          emptyShow.value = true;
        } else {
          emptyShow.value = false;
        }
      } catch (error) {
        console.error(error);
      }
    };
    //已读
    const readMethod = async message => {
      try {
        const {
          code,
          msg
        } = await readApi({
          allReaded: true,
          messagType: type,
          messageId: ""
        });
        if (code !== 9000) {
          $alert({
            msg
          });
          return;
        }
      } catch (error) {
        console.error(error);
      }
    };
    const clickItem = message => {
      toServerRouting(message.paramJson);
      // window.open('https://www.baidu.com')
    };

    const shouldHideTitleBar = () => {
      return true;
    };
    return (_ctx, _cache) => {
      const _component_nav_bar = _resolveComponent("nav-bar");
      const _component_van_empty = _resolveComponent("van-empty");
      const _component_van_list = _resolveComponent("van-list");
      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_nav_bar, {
        title: showTitle.value
      }, null, 8, ["title"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_pull_refresh, {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => refreshing.value = $event),
        onRefresh: getData
      }, {
        default: _withCtx(() => [_withDirectives(_createVNode(_component_van_empty, {
          description: "暂无消息",
          image: require('@/assets/image/message_empty.png')
        }, null, 8, ["image"]), [[_vShow, emptyShow.value]]), _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = $event => loading.value = $event),
          finished: finished.value,
          "finished-text": "",
          onLoad: loadData,
          "error-text": "加载失败",
          "immediate-check": false
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageList.value, message => {
            return _openBlock(), _createElementBlock("div", {
              class: "item",
              key: message.id
            }, [_createElementVNode("div", _hoisted_3, _toDisplayString(getDateTime(message.createdTime)), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(message.title), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(message.content), 1), _hoisted_7, _createElementVNode("div", {
              class: "item-body-btn",
              onClick: $event => clickItem(message)
            }, _hoisted_11, 8, _hoisted_8)])]);
          }), 128))]),
          _: 1
        }, 8, ["loading", "finished"])]),
        _: 1
      }, 8, ["modelValue"])])]);
    };
  }
};